import axios from "axios";
import store from "../../../../../../stores/application/index.js.erb";
import _ from "lodash";

const scholarshipMeetingPath = `/scholarship/meeting/meetings`;

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
};

const transformStatesResponse = (response) => {
    return {
        data: {
            competition: _.pick(response.data.competition,
                ['id', 'prtf_achievement_type_id', 'selectedId', 'updated_at']),
        }
    }
};

const showErrorMessage = (message) => {
    return store.dispatch("error_portfolio/addError", {
        type: "Error Server",
        message: message,
        context: "Error Server",
        show: true
    });
};

const errorCode = (errorResponse) => {
    if (errorResponse.status === 404) return showErrorMessage(errorResponse.data.error.message)

    if (errorResponse.status === 422) return showErrorMessage(errorResponse.data.error.message)

    return showErrorMessage("Неизвестная ошибка сервера");
}

const ScholarshipMeetingApi = {

    async index() {
        get_token();
        try {
            return await axios.get(`${scholarshipMeetingPath}`);
        } catch (error) {
            errorCode(error.response);
            return null;
        }
    },

    async show(id) {
        get_token();
        try {
            return await axios.get(`${scholarshipMeetingPath}/${id}`);
        } catch (error) {
            errorCode(error.response);
            return null;
        }
    },

    async update(id, payload) {
        get_token();
        try {
            return await axios.patch(`${scholarshipMeetingPath}/${id}`, {scholarship_meeting: payload});
        } catch (error) {
            errorCode(error);
            return null;
        }
    },

    async backupFilesCompetitionsForMeeting(id) {
        get_token();
        try {
            return await axios.get(`${scholarshipMeetingPath}/${id}/backup`, {responseType: 'blob'});
        } catch (error) {
            errorCode(error);
            return null;
        }
    },

    async backupFilesCompetitionForId(idMeeting, idStatement) {
        get_token();
        try {
            return await axios.get(`${scholarshipMeetingPath}/${idMeeting}/backup/${idStatement}`, {responseType: 'blob'});
        } catch (error) {
            errorCode(error);
            return null;
        }
    },

    async searchPerson(search){
        get_token();
        try {
            return await axios.get(`${scholarshipMeetingPath}/search_person?q=${search}`);
        } catch (error) {
            errorCode(error);
            return null;
        }
    },

    async getAchievementType(){
        get_token();
        try {
            return await axios.get(`/scholarship/meeting/scholarship_achievement_type`);
        } catch (error) {
            errorCode(error);
            return null;
        }
    },

    async getAchievementParameters() {
        get_token();
        try {
            return await axios.get(`/scholarship/meeting/scholarship_edit_achievement`);
        } catch (error) {
            errorCode(error);
            return null;
        }
    }

}

export default ScholarshipMeetingApi;